// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__WM1xQ","footer":"ReportModalFilter_footer__2uhxe"};